import tabs from './src/tabs'

/* istanbul ignore next */
tabs.install = function (Vue) {
  Vue.component(tabs.name, tabs)
}

export default tabs
